export default __webpack_public_path__ + "static/featured-image-156b9c2e94002bec3db7046f84f73e8f.png";